import React from 'react';
import { NumericFormatField } from '../../Forms/Fields';
import { AssetAdvisoryFormValues, useAssetAdvisoryAccordions } from './useAssetAdvisoryForm';
import { ControlledAccordionItem } from '../../common/ControlledAccordion';

export function MarketInvestmentsAccordion() {
  const { isMarketInvestmentsAccordionFilled } = useAssetAdvisoryAccordions();

  return (
    <ControlledAccordionItem
      button={{ title: 'Inversiones en Mercado Financiero', tooltip: { content: 'No considera los activos alternativos', title: 'Recuerda que:' } }}
      eventKey="1"
      isFilled={isMarketInvestmentsAccordionFilled}
      isOpenRequired
    >
      <div className="d-flex flex-column gap-4">

        <NumericFormatField<AssetAdvisoryFormValues>
          id="clp_capital_markets_investment"
          path="clp_capital_markets_investment"
          label="¿Cuánto tienes en Inversiones de Mercados Financieros nacionales o internacionales?"
          prefix="$ "
          placeholder="$"
        />

        <NumericFormatField<AssetAdvisoryFormValues>
          id="uf_capital_markets_investment"
          path="uf_capital_markets_investment"
          prefix="UF "
          placeholder="UF"
        />

        <NumericFormatField<AssetAdvisoryFormValues>
          id="usd_capital_markets_investment"
          path="usd_capital_markets_investment"
          prefix="USD "
          placeholder="USD"
        />

        <NumericFormatField<AssetAdvisoryFormValues>
          id="clp_alt_assets"
          path="clp_alt_assets"
          label="¿Cuánto tienes en Activos Alternativos nacionales o internacionales?"
          prefix="$ "
          placeholder="$"
        />

        <NumericFormatField<AssetAdvisoryFormValues>
          id="uf_alt_assets"
          path="uf_alt_assets"
          prefix="UF "
          placeholder="UF"
        />

        <NumericFormatField<AssetAdvisoryFormValues>
          id="usd_alt_assets"
          path="usd_alt_assets"
          prefix="USD "
          placeholder="USD"
        />

        <NumericFormatField<AssetAdvisoryFormValues>
          id="apv"
          path="apv"
          label="¿Cuánto tienes en APV y/o Depósitos convenidos?"
          prefix="$ "
          placeholder="$"
        />
      </div>
    </ControlledAccordionItem>

  );
}
